// List of all filters that FA can accept and render

export const BODY_FILTERS_LIST_NEW = ['suv', 'limousine', 'sportback', 'allroad-quattro', 'avant'];

export const BODY_FILTERS_LIST_USED = [
  'suv',
  'limousine',
  'sportback',
  'allroad-quattro',
  'coupe',
  'cabriolet',
  'avant',
  'spyder',
  'roadster',
];

export const EXT_COLOR_FILTERS = [
  'black',
  'white',
  'gray',
  'silver',
  'blue',
  'red',
  'green',
  'brown',
  'yellow',
  'beige',
  'orange',
  'default',
];

export const INT_COLOR_FILTERS = ['black', 'gray', 'white', 'red', 'brown', 'beige', 'default'];

export const CA_TRIMLINE_FILTERS = ['comfort', 'progressive', 'technik'];

export const US_TRIMLINE_FILTERS = ['premium', 'premium_plus', 'prestige', 'default'];

export const FUEL_FILTERS_NEW = ['gasoline', 'electrical', 'gasoline_hybrid'];

export const FUEL_FILTERS_USED = ['gasoline', 'electrical', 'gasoline_hybrid', 'diesel'];

export const DRIVE_FILTERS = ['quattro', 'rwd', 'fwd'];

export const WHEEL_SIZE_FILTERS = ['15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];

export const GEARBOX_FILTERS = ['automatic', 'manual'];

export const PRICE_FILTERS_NEW = [
  {
    key: 'min',
    values: [20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000],
  },
  {
    key: 'max',
    values: [30000, 40000, 50000, 60000, 70000, 80000, 90000, 250000],
  },
];

export const PRICE_FILTERS_USED = [
  {
    key: 'min',
    values: [20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000],
  },
  {
    key: 'max',
    values: [30000, 40000, 50000, 60000, 70000, 80000, 90000, 250000],
  },
];

export const POWER_FILTERS = [
  {
    key: 'min',
    values: [0, 200, 250, 300, 350, 400, 500, 600],
  },
  {
    key: 'max',
    values: [0, 200, 250, 300, 350, 400, 500, 1000],
  },
];

export const MILEAGE_FILTERS = [
  {
    key: 'min',
    values: [0, 20000, 30000, 40000, 50000, 60000, 700000, 80000, 90000, 100000],
  },
  {
    key: 'max',
    values: [5000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 300000],
  },
];
